import DOMPurify from 'dompurify';

// Any unicode letter, number or specific special characters
export const VALID_NAME_INPUT_REGEX = /^[\p{L}\p{N}\-_.,()/'&:!@% ]+$/u;

/**
 * Validate if a name matches the legal name pattern
 * @param {string} name - The name to validate
 * @returns {boolean} True if the name is valid, false otherwise
 */
export const validateName = (name) => {
    if (!name || name == undefined) return false;
    return VALID_NAME_INPUT_REGEX.test(name);
};

// Configure DOMPurify with our security settings
DOMPurify.setConfig({
    ALLOWED_TAGS: [], // Remove all HTML tags
    ALLOWED_ATTR: [], // Remove all attributes
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onmouseout', 'onkeydown', 'onkeypress', 'onkeyup'],
});

/**
 * Sanitize input string to prevent XSS attacks
 * @param {string} input - The string to sanitize
 * @returns {string} The sanitized string
 */
export const sanitize = (input) => {
    if (!input) return input;
    return DOMPurify.sanitize(input);
};